<h2 mat-dialog-title>
  {{ title }}
  <mat-divider></mat-divider>
</h2>

<mat-dialog-content>
  @if (languages.length > 1) {
    <div class="mb-3">
      <label for="pdf-text-language">Sprog</label>
      <mat-form-field>
        <mat-select
          id="pdf-text-language"
          [(value)]="selectedLanguage"
          (selectionChange)="onLanguageChange()"
          [disabled]="loading || saving"
        >
          @for (lang of languages; track lang) {
            <mat-option [value]="lang">{{ lang }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  @if (loading) {
    <div fxLayout="row" fxLayoutAlign="center center" class="py-4">
      <mat-spinner diameter="40" role="status" [attr.aria-label]="'Indlæser'"></mat-spinner>
    </div>
  }

  <form [formGroup]="form" [style.display]="loading ? 'none' : 'block'">
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <div fxFlex="45" fxLayout="column">
        <mat-form-field class="mb-3">
          <mat-label>Filnavn</mat-label>
          <input
            id="pdf-filename"
            matInput
            formControlName="filename"
            placeholder="Udbetalingsbilag %{date}.pdf"
          >
          <mat-hint>Understøtter {{ '%{date}' }} og {{ '%{journal_no}' }} variable.</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Øverst til venstre (Modtager)</mat-label>
          <textarea
            id="pdf-top-left"
            matInput
            rows="6"
            formControlName="top_left"
          ></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nederst til venstre (Bankoplysninger)</mat-label>
          <textarea
            id="pdf-bottom-left"
            matInput
            rows="6"
            formControlName="bottom_left"
          ></textarea>
        </mat-form-field>      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="45" fxLayout="column">
        <mat-form-field>
          <mat-label>Beløbsoverskrift</mat-label>
          <input
            id="pdf-payment-label"
            matInput
            formControlName="payment_label"
            placeholder="Udbetalt beløb"
          >
          <mat-hint>Tekst for denne postering</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Øverst til højre (Bilagsoplysninger)</mat-label>
          <textarea
            id="pdf-top-right"
            matInput
            rows="6"
            formControlName="top_right"
          ></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nederst til højre (Afsender)</mat-label>
          <textarea
            id="pdf-bottom-right"
            matInput
            rows="6"
            formControlName="bottom_right"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close [attr.aria-label]="'Luk'" [disabled]="saving">Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid || loading || saving" [attr.aria-label]="'Gem'">
    {{ saving ? 'Gemmer...' : 'Gem' }}
  </button>
</mat-dialog-actions>
